import React from 'react';
// import LazyLoad from "react-lazyload";
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import useBreakpoint from 'utils/hooks/useBreakpoint';
import useDeviceWidth from 'utils/hooks/useDeviceWidth';
import breakpoints from 'utils/breakpoints';
import OpenNewTab from 'components/icons/OpenNewTab';

const Container = styled.div``;

const CardBody = styled.a`
  ${({ isOnePerPage, mobileCardWidth }) =>
    isOnePerPage && mobileCardWidth && `min-width:${mobileCardWidth}px;`}
  max-width: 22.5rem;
  height: 32rem;
  transition: all 0.4s ease-out;
  @media ${breakpoints.sm} {
    min-width: 22.5rem;
  }
`;

const Overlay = styled.div`
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.5956757703081232) 17%,
    rgba(255, 255, 255, 0) 87%
  );
`;

const TitleCard = styled.div`
  text-shadow: 0 0 25px rgba(0, 0, 0), 0 0 20px rgba(0, 0, 0),
    0 0 20px rgba(0, 0, 0);
`;

const PortraitCard = ({ indexAria, card = {}, type = 'home', ...rest }) => {
  const breakpoint = useBreakpoint(
    typeof window !== 'undefined' && window.innerWidth,
  );
  const isMobile = ['sm', 'xs', 'md'].includes(breakpoint);
  const isOnePerPage = ['xs'].includes(breakpoint);
  const deviceWidth = useDeviceWidth();
  const mobileCardWidth = deviceWidth && Math.round(deviceWidth * 0.8);

  const href = card.ctaLink && card.ctaLink.href;
  const target = card.ctaLink && card.ctaLink.target;

  return (
    <Container {...rest}>
      <CardBody
        className='relative w-full flex flex-col rounded overflow-hidden cursor-pointer'
        isMobile={isMobile}
        isOnePerPage={isOnePerPage}
        mobileCardWidth={mobileCardWidth}
        href={href}
        target={target || '_self'}
        aria-label={`${card.firstText} ${card.secondText}. ${
          target === '_blank' ? 'Opens in new tab' : ''
        }. ${card.image && card.image.alt}`}
      >
        <div className='h-full w-full relative'>
          <div>
            <img
              className='absolute left-0 top-0 object-cover h-full min-w-full'
              src={card.image && card.image.src}
              alt={card.image && card.image.alt}
            />
          </div>
        </div>
        <Overlay className='absolute bottom-0 w-full h-1/2'></Overlay>
        <div className='absolute bottom-0 left-0 ml-5 mb-4 z-10'>
          <TitleCard className='font-trade-gothic-20 text-3xl text-white  pr-24 mr-4'>
            <p className='text-base	 font-graphie text-white mb-1'>
              {card.firstText}
            </p>
            <h2 className='uppercase'>{card.secondText}</h2>
            {target === '_blank' && (
              <OpenNewTab className='mb-4 w-5 absolute  bottom-0 right-0 ' />
            )}
          </TitleCard>
        </div>
      </CardBody>
    </Container>
  );
};

PortraitCard.propTypes = {
  card: PropTypes.object,
};

export default PortraitCard;
